import { useEffect, useState } from 'react';
import { GridSkeleton } from 'components/Grid';
import ScalarSpreadsheet from 'components/ScalarSpreadsheet';
import useWorkbook from 'components/ScalarSpreadsheet/utilities/useWorkbook';
import useWaterfallBreakpointsTableData from './useWaterfallBreakpointsTableData';
import { WaterfallBreakpointsProps } from '../../types/breakpoint-analysis.models';

const WaterfallBreakpoints = ({ waterfallColumns, format, hideGrid }: WaterfallBreakpointsProps) => {
  const { spreadsheet: WaterfallBreakpointsDetailSheet } = useWaterfallBreakpointsTableData({
    waterfallColumns,
    format,
  });

  const [spreadsheets, setSpreadsheets] = useState([WaterfallBreakpointsDetailSheet]);

  useEffect(() => {
    if (WaterfallBreakpointsDetailSheet?.yLength > 0) {
      setSpreadsheets([WaterfallBreakpointsDetailSheet]);
    }
  }, [WaterfallBreakpointsDetailSheet]);

  const { onChange, workbook } = useWorkbook(spreadsheets);

  const WaterfallBreakpointsDetailSheetProps = {
    ...WaterfallBreakpointsDetailSheet,
    sheet: WaterfallBreakpointsDetailSheet!,
    workbook,
    onChange,
    page: 'captable',
    className: 'waterfall-custom-width',
    data: WaterfallBreakpointsDetailSheet?.data ?? [],
  };

  if (hideGrid) {
    return null;
  }

  return WaterfallBreakpointsDetailSheet?.data ? (
    <ScalarSpreadsheet {...WaterfallBreakpointsDetailSheetProps} page={'captable'} />
  ) : (
    <GridSkeleton />
  );
};

export default WaterfallBreakpoints;
